// src/components/perfiles/FormularioSimpatizante.jsx
import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Card, CardContent, Alert, FormControlLabel, Checkbox } from '@mui/material';

const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '12px',
    '& fieldset': { borderColor: 'rgba(30, 136, 229, 0.3)', borderWidth: '2px' },
    '&:hover fieldset': { borderColor: '#1E88E5' },
    '&.Mui-focused fieldset': { borderColor: '#1E88E5' }
  }
};

const FormularioSimpatizante = ({ perfil, onVolver }) => {
  const [formData, setFormData] = useState({
    nombre: '', apellido: '', email: '', phoneNumber: '', aceptaTerminos: false
  });

  const handleChange = (field) => (event) => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    console.log('Registro simpatizante:', formData);
    alert('¡Gracias por unirte!');
    onVolver();
  };

  return (
    <Card sx={{ borderRadius: '20px', maxWidth: 600, mx: 'auto' }}>
      <CardContent sx={{ p: 4 }}>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Box sx={{ fontSize: '60px', mb: 2 }}>{perfil.emoji}</Box>
          <Typography variant="h5" fontWeight={700} mb={1}>{perfil.titulo}</Typography>
          <Typography variant="body2" color="text.secondary">Solo necesitamos tus datos básicos. ¡Menos de 2 minutos!</Typography>
        </Box>

        <Alert severity="success" sx={{ mb: 3, borderRadius: '12px' }}>
          Como simpatizante: <strong>sin cuotas, sin compromisos</strong>. Solo apoyo al movimiento.
        </Alert>

        <Box sx={{ display: 'grid', gap: 2 }}>
          <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 2 }}>
            <TextField label="Nombre" value={formData.nombre} onChange={handleChange('nombre')} sx={textFieldStyles} required />
            <TextField label="Apellido" value={formData.apellido} onChange={handleChange('apellido')} sx={textFieldStyles} required />
          </Box>
          <TextField label="Email" type="email" value={formData.email} onChange={handleChange('email')} sx={textFieldStyles} required />
          <TextField label="Celular" value={formData.phoneNumber} onChange={handleChange('phoneNumber')} sx={textFieldStyles} required />
          <FormControlLabel control={<Checkbox checked={formData.aceptaTerminos} onChange={handleChange('aceptaTerminos')} />} label="Acepto recibir información del movimiento" />
        </Box>

        <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
          <Button variant="outlined" onClick={onVolver} fullWidth sx={{ borderRadius: '12px' }}>Cancelar</Button>
          <Button variant="contained" onClick={handleSubmit} fullWidth sx={{ borderRadius: '12px', backgroundColor: perfil.color }}>Unirme</Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default FormularioSimpatizante;